// extracted by mini-css-extract-plugin
module.exports = {"holder":"App_holder__V0iKu"};